export default (state) => (state.customer
  && state.customer.metadata
  && state.customer.metadata.premium
  && state.customer.metadata.premium.appleAppId) || 1320617173
